import type { ReactNode } from "react";
import { useAuth } from "../../auth/AuthContext";
import { EmptyState } from "../../components/AsyncStates";

/**
 * UX-only gate for the admin-only pages (Users, Audit log, Governance
 * Decisions — the last two both read the `audit_log:view`-scoped
 * `/api/audit-events` endpoint, ADR-0058). The real boundary is server-side
 * on every request (charter S-8) — this only saves a non-admin who lands
 * here directly (the nav item hiding them from the link is itself UX too,
 * see NavSidebar) from a confusing 403, by not even firing the request.
 * Never treat this as the authorization decision.
 */
export function AdminGate({ children }: { children: ReactNode }) {
  const { session } = useAuth();
  if (session?.role !== "admin") {
    return (
      <EmptyState
        title="Admins only"
        description="This area is limited to admin accounts. Ask an admin if you need access."
      />
    );
  }
  return <>{children}</>;
}
